import { RiskAreaTab, riskAreaTabFromQuery, riskAreaTabToQuery } from "./RiskArea.types";

const viewStorageKeyPrefix = "risk-area-view-";

export function rememberRiskAreaTab(riskAreaId: string, tab: RiskAreaTab) {
    localStorage.setItem(viewStorageKeyPrefix + riskAreaId, riskAreaTabToQuery(tab));
}

// The nav menu links straight to the view the user last had open on the area, so leaving for another menu
// item and coming back lands where they left off.
export function readRememberedRiskAreaTab(riskAreaId: string): RiskAreaTab {
    return riskAreaTabFromQuery(localStorage.getItem(viewStorageKeyPrefix + riskAreaId));
}
